import { object } from 'prop-types'
import { connect } from 'react-redux'
import React from 'react'
import { Link } from 'react-router-dom'
import { setHeaderTitleArray } from '../../store/layout/actionCreator'
import EnterpriseIcon, {
  ListUnorderedIcon,
  HistoryIcon,
  TruckIcon,
} from '@enterprise-ui/icons'
import { Card } from '@enterprise-ui/canvas-ui-react'
import '../../styles/vendorPageLogin.scss'

class VendorLoginPage extends React.Component {
  componentDidMount() {
    const { setHeaderTitleArray } = this.props
    setHeaderTitleArray([])
  }

  static propTypes = {
    classes: object,
  }

  render() {
    return (
      <div className="vendor-login-page">
        <p className="vendor-login-intro">Pegasus Sample Management</p>
        <div style={{ width: '804px', margin: 'auto' }}>
          <Link to="/orderSummary" style={{ textDecoration: 'none' }}>
            <Card
              elevation={0}
              corners="none"
              className="vendor-card"
              style={{ float: 'left' }}
            >
              <p className="card-title">REQUESTED SAMPLES</p>
              <div style={{ margin: '37px 0px', textAlign: 'center' }}>
                <EnterpriseIcon
                  className="vendor-icon"
                  icon={ListUnorderedIcon}
                />
              </div>
              <div>
                <p className="card-text">
                  See the samples Target has requested and let Target know your
                  samples are on the way.
                </p>
              </div>
            </Card>
          </Link>
          <Link to="/shipmentSummary" style={{ textDecoration: 'none' }}>
            <Card
              elevation={0}
              corners="none"
              className="vendor-card"
              style={{ float: 'right' }}
            >
              <p className="card-title">SAMPLE HISTORY</p>
              <div style={{ margin: '37px 0px', textAlign: 'center' }}>
                <EnterpriseIcon className="vendor-icon" icon={HistoryIcon} />
                <EnterpriseIcon className="vendor-icon" icon={TruckIcon} />
              </div>
              <div>
                <p className="card-text">
                  View the history of past shipments and add missing shipping
                  details.
                </p>
              </div>
            </Card>
          </Link>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setHeaderTitleArray: (headerTitleArray) =>
      dispatch(setHeaderTitleArray(headerTitleArray)),
  }
}

export default connect(null, mapDispatchToProps)(VendorLoginPage)
